var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var LabelStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    padding: 0.5rem 0.75rem;\n    margin: 0.25rem;\n    background-color: #68788d;\n    color: #fff;\n    border-radius: 9999px;\n    border-width: 1px;\n    border-color: #2e3439;\n\n    a {\n        color: #68788d;\n    }\n"], ["\n    display: inline-block;\n    padding: 0.5rem 0.75rem;\n    margin: 0.25rem;\n    background-color: #68788d;\n    color: #fff;\n    border-radius: 9999px;\n    border-width: 1px;\n    border-color: #2e3439;\n\n    a {\n        color: #68788d;\n    }\n"])));
export var Label = function (_a) {
    var children = _a.children;
    return _jsx(LabelStyle, { children: children }, void 0);
};
Label.displayName = 'NekoLabel';
var templateObject_1;
